import { Divider } from 'antd';
import { SelectDrawer } from '@Components/Base';
import { OptionExtended } from '@Components/types/options';
import styles from './PricingSelectType.module.css';

const selectOptions = [
  { label: 'LPO', value: 'first' },
  { label: 'LOI', value: 'second' },
] as OptionExtended[];

interface PricingSelectTypeProps {
  selectedValue?: string;
  handleSelect?: (label: string, value: string | null) => void;
  onRequestSelectorOpen?: () => void;
}

const PricingSelectType: React.FC<PricingSelectTypeProps> = ({
  handleSelect,
  onRequestSelectorOpen,
  selectedValue = '',
}) => {
  return (
    <div className={styles.selectTypeSection}>
      <span>Previous Price Type</span>
      <Divider className={styles.divider} type="vertical" />

      <SelectDrawer
        items={selectOptions}
        caption={selectedValue}
        title="Select Price Type"
        handleSelect={handleSelect}
        onOpen={onRequestSelectorOpen}
        name="priceType"
      />
    </div>
  );
};

export default PricingSelectType;
